import { createStyles } from 'antd-style'

const LIST_HEIGHT = 420
const SIDEBAR_WIDTH = 232

export const useStyles = createStyles(({ token, css }) => {
  return {
    sidebar: {
      width: SIDEBAR_WIDTH,
      flex: `0 0 ${SIDEBAR_WIDTH}px`,
      overflowY: 'auto',
      paddingRight: token.paddingXXS,
      borderInlineEnd: `1px solid ${token.colorBorderSecondary}`
    },

    groupTitle: {
      padding: `${token.paddingXS}px ${token.paddingSM}px 0`,
      fontSize: token.fontSizeSM,
      textTransform: 'uppercase',
      letterSpacing: 0.6
    },

    categoryItem: css`
      display: flex;
      gap: ${token.marginXS}px;
      align-items: center;
      width: 100%;
      padding: ${token.paddingXS}px ${token.paddingSM}px;
      color: ${token.colorText};
      text-align: start;
      background: transparent;
      border: none;
      border-radius: ${token.borderRadius}px;
      cursor: pointer;
      transition: background ${token.motionDurationMid};

      &:hover {
        background: ${token.colorFillQuaternary};
      }
    `,

    categoryItemActive: css`
      color: ${token.colorPrimary};
      background: ${token.colorPrimaryBg};

      &:hover {
        background: ${token.colorPrimaryBg};
      }
    `,

    categoryTitle: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    content: {
      minWidth: 0
    },

    list: {
      height: LIST_HEIGHT,
      overflowY: 'auto',
      position: 'relative',
      paddingInline: token.paddingSM
    },

    divider: {
      margin: 0
    },

    sectionHeader: {
      paddingTop: token.paddingLG,
      paddingBottom: token.paddingXS
    },

    sectionIndex: {
      fontFamily: token.fontFamilyCode,
      fontSize: token.fontSizeSM
    },

    row: {
      paddingBlock: token.paddingSM
    },

    rowContent: {
      minWidth: 0
    },

    code: {
      fontSize: token.fontSizeSM
    },

    empty: {
      paddingBlock: token.paddingXL
    }
  }
})
